<template>
  <div class="relative h-32 w-32 overflow-hidden md:h-[136px] md:w-[136px]">
    <img
      :src="url"
      :alt="alt"
      class="absolute h-full w-full object-contain"
      :class="imageClass"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  imageClass: [String, Array],
  url: String,
  alt: String,
})
</script>
